import { action, observable } from 'mobx';
import QuizItemSettings from './QuizItemSettings';


export class PhoneItemSettings extends QuizItemSettings {
    constructor(s?: Partial<PhoneItemSettings>) {
        super();
        if (s)
            this.update(s);
    }

    @observable defaultCountryId: string | null;

    @action update(q: Partial<PhoneItemSettings>, allowUndefined = false) {
        super.update(q, allowUndefined);
    }

    static build(def?: Partial<PhoneItemSettings>) {
        return new PhoneItemSettings({
            ...QuizItemSettings.default,
            defaultCountryId: null,
            ...def
        });
    }

    clone() {
        return new PhoneItemSettings({
            ...this
        });
    }

    static fromJson(json: any) {
        return PhoneItemSettings.build(json);
    }
}
